<p-dialog
	[header]="''"
	[(visible)]="show"
	[modal]="true"
	[closable]="true"
	[closeOnEscape]="true"
	[dismissableMask]="true"
	[breakpoints]="{'1378px': '70vw', '1280px': '75vw', '991px': '85vw', '768px': '92vw', '640px': '96vw'}"
	[style]="{width: '60vw'}"
	[draggable]="false"
	[resizable]="false"
	[position]="'center'"
	[transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'"
	(onHide)="hiddenModal()">

	<!-- WhatsApp Button - Esquina del Modal -->
	<div class="whatsapp-modal">
		<a [href]="whatsappUrl" target="_blank" class="flex items-center justify-center w-14 h-14 bg-[#25d366] rounded-full shadow-[0_4px_12px_rgba(37,211,102,0.4)] hover:shadow-[0_6px_16px_rgba(37,211,102,0.5)] hover:scale-110 transition-all duration-300 cursor-pointer">
			<i class="pi pi-whatsapp text-white text-[1.75rem]"></i>
		</a>
	</div>

	<div class="relative max-w-4xl mx-auto mt-2 animate-fade-in-up">

		<!-- Header -->
		<div class="text-center mb-6">
			<h1 class="font-bold text-3xl sm:text-4xl md:text-5xl tracking-wide mb-3" style="color: #004aad;">
				PORTAL DE PAGOS
			</h1>
			<p class="text-base sm:text-lg md:text-3xl text-black font-normal">
				Mantén tu cupo al día de forma fácil y ágil.
			</p>
		</div>

		<!-- PSE Logo -->
		<div class="flex flex-col items-center gap-5 mb-6">
			<div class="pse-wrapper cursor-pointer hover:scale-105 transition-all duration-300" (click)="goToSimilpay()">
				<img [src]="similpayLogo" alt="PSE Logo" class="pse-logo" />
			</div>

			<!-- Alternative Payment Link -->
			<div class="text-center">
				<p class="text-2xl text-black mb-3 font-normal">O usa:</p>
				<a
					(click)="goToAvalPay()"
					class="inline-block px-10 py-2.5 rounded-full font-semibold cursor-pointer tracking-wider text-base transition-all duration-300 aval-pay-btn">
					AVAL PAY CENTER
				</a>
			</div>
		</div>

	</div>
</p-dialog>
